import * as React from "react";

const QtyPlusIcon: React.FC = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_42528_22706)">
                <path d="M12.375 6.14621H7.07434V0.824961C7.07434 0.577461 6.86809 0.350586 6.59996 0.350586C6.35246 0.350586 6.12559 0.556836 6.12559 0.824961V6.14621H0.824961C0.577461 6.14621 0.350586 6.35246 0.350586 6.62058C0.350586 6.86808 0.556836 7.09496 0.824961 7.09496H6.14621V12.375C6.14621 12.6225 6.35246 12.8493 6.62058 12.8493C6.86808 12.8493 7.09496 12.6431 7.09496 12.375V7.07434H12.375C12.6225 7.07434 12.8493 6.86809 12.8493 6.59996C12.8493 6.35246 12.6225 6.14621 12.375 6.14621Z" fill="#414243"/>
            </g>
            <defs>
                <clipPath id="clip0_42528_22706">
                    <rect width="13.2" height="13.2" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(QtyPlusIcon);